import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
const DEFAULT_TLDS = ['com', 'org', 'net', 'ai', 'online', 'co'];
export const getTldSelectorData = async _ref => {
  let {
    httpClient,
    request: {
      limit
    }
  } = _ref;
  const {
    listTldPromotions,
    domainsAccount
  } = DomainsApiClient.queries({
    httpClient
  });
  try {
    const [listTldPromotionsResult, domainsAccountResult] = await Promise.allSettled([listTldPromotions({
      limit
    }), domainsAccount({})]);
    const tldPromotions = (listTldPromotionsResult.status === 'fulfilled' ? listTldPromotionsResult.value.tldPromotions : null) ?? DEFAULT_TLDS.map(tld => ({
      tld
    }));
    const voucherSupportedTlds = domainsAccountResult.status === 'fulfilled' ? domainsAccountResult.value.voucherSupportedTlds : [];
    const tldSelectorData = tldPromotions.map(_ref2 => {
      let {
        tld
      } = _ref2;
      return {
        tld: tld,
        isVoucherSupported: (voucherSupportedTlds == null ? void 0 : voucherSupportedTlds.includes(tld)) ?? false
      };
    });
    if (!tldSelectorData.length) {
      return {
        tldSelectorData: DEFAULT_TLDS.map(tld => ({
          tld,
          isVoucherSupported: false
        }))
      };
    }
    return {
      tldSelectorData
    };
  } catch (e) {
    return {
      tldSelectorData: DEFAULT_TLDS.map(tld => ({
        tld,
        isVoucherSupported: false
      }))
    };
  }
};
//# sourceMappingURL=getTldSelectorData.js.map